// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyDl-_spaa2ZMb7M5tiv1GXH0uIoXRdyymQ",
    authDomain: "sixteen-angles-prod.firebaseapp.com",
    databaseURL: "https://sixteen-angles-prod.firebaseio.com",
    projectId: "sixteen-angles-prod",
    storageBucket: "sixteen-angles-prod.appspot.com",
    messagingSenderId: "453956915240",
    appId: "1:453956915240:web:fdfa83fea6e122fbb3651d",
    measurementId: "G-PCKTQBFC40"
  },
  baseApiUrl: 'https://us-central1-sixteen-angles-prod.cloudfunctions.net/api'
}
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
